import http from '@/http/driver'


export default {
    planner: {
        search(data = {}) {
            console.log(data)
            return http({ url: '/v1/journey-planner/search', method: 'post', data })
        },
        getJourneys(hash) {
            return http({ url: `/v1/journey-planner/search/${hash}` })
        },
        getSingleJourney(hash, journeyID) {
            return http({ url: `/v1/journey-planner/search/${hash}/${journeyID}` })
        },
        updateReturnTime(hash, data = {}) {
            return http({ url: `/v1/journey-planner/search/${hash}/update-return-time`, method: 'post', data })
        },
    },
    journey: {
        saveJourney(journeyID) {
            return http({
                url: `/v1/journey/save/${journeyID}`,
                method: 'post',
            })
        },
        journeyViewed(journeyID) {
            return http({
                url: `/v1/journey/viewed/${journeyID}`,
                method: 'post',
            })
        },
    },
    users: {
        register(params) {
            return http({
                url: '/v1/users/register',
                method: 'post',
                data: params,
            })
        },
        update(params) {
            return http({
                url: '/v1/users/update',
                method: 'put',
                data: params,
            })
        },
        activate(code) {
            return http({
                url: `/v1/users/activation/${code}`,
                method: 'post',
                code,
            })
        },
        passwordReset(params) {
            return http({
                url: '/v1/users/password/reset',
                method: 'post',
                data: params,
            })
        },
        changePasswordRequest(params) {
            return http({
                url: `/v1/users/password/reset/${params.code}`,
                method: 'post',
                data: {
                    password: params.password,
                    password_confirmation: params.password_confirmation,
                },
            })
        },
        fetchAuthenticatedUser() {
            return http({
                url: '/v1/users/show',
                method: 'get',
            })
        },
        usersRecentJourneys(params) {
            return http({
                url: '/v1/journey-planner/queries/user',
                method: 'get',
                params,
            })
        },
        usersSavedJourneys(params) {
            return http({
                url: '/v1/journey/saved/user',
                method: 'get',
                params,
            })
        },
        userSaveJourneyRequest(journeyID) {
            return http({
                url: `/v1/journey/save/${journeyID}`,
                method: 'post',
            })
        },
    },
    auth: {
        login(params) {
            return http({
                url: '/v1/auth/login',
                method: 'post',
                data: params,
            })
        },
    },
    campaigns: {
        getActiveCampaign(params) {
            return http({
                url: '/v1/campaign',
                method: 'get',
                params,
            })
        },
        recordCampaignImpression(params) {
            return http({
                url: `/v1/campaign/${params.campaign_id}/impression`,
                method: 'post',
                data: params,
            })
        },
    },
}
